<template>
  <v-container fluid class="main-container" style="text-align: center;">
    <PageHeader
      header="Add X-ray Sample"
      :subheader="activeService.name || 'No service selected'"
      class=" mb-10"
    />

    <UserCode
      @onInvalidUserCode="onInvalidUserCode"
      @onValidUserCode="onValidUserCode"
    />

    <UserInfo :code="userCode" />
    <UserImage :code="userCode" :serviceId="activeService.id" />

    <v-row>
      <v-col style="text-align: center">
        <img
          :src="imageSrc"
          v-show="isUserCodeValid"
          style="border: solid; min-height: 50px; min-width: 300px; width: 600px"
        />
      </v-col>
    </v-row>

    <input
      ref="input"
      v-show="isUserCodeValid"
      type="file"
      accept="image/*"
      @change="setImage"
      style="max-width: 320px"
    />

    <v-row class="mt-10">
      <v-btn
        v-show="isUserCodeValid"
        :disabled="!isUserCodeValid || lastImageSrc == imageSrc"
        @click="addXraySample"
        color="primary"
        style="margin: auto; max-width: 320px;"
      >
        {{ lastImageSrc ? "Update X-ray Sample" : "Add X-ray Sample" }}
      </v-btn>
    </v-row>

    <ErrorMessage :errorMessage="errorMessage" />

    <ConfirmDlg ref="confirm" />
  </v-container>
</template>

<script>
import { AddXraySubmission, GetXraySubmission } from "@/store/xray";
import { GetActiveOffsiteService } from "@/store/offsiteService";

import ConfirmDlg from "@/components/ConfirmDlg.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import PageHeader from "@/components/PageHeader.vue";
import UserCode from "@/components/UserCode.vue";
import UserImage from "@/components/UserImage.vue";
import UserInfo from "@/components/UserInfo.vue";

export default {
  name: "AddSample",

  components: {
    ConfirmDlg,
    ErrorMessage,
    PageHeader,
    UserCode,
    UserImage,
    UserInfo
  },

  data: () => ({
    imageSrc: "",
    lastImageSrc: "",

    activeService: { id: null, name: null },
    isXraySubmitted: true,

    isUserCodeValid: false,
    userCode: "",

    errorMessage: ""
  }),

  mounted() {
    this.activeService = GetActiveOffsiteService();
  },

  methods: {
    addXraySample() {
      AddXraySubmission(
        this.activeService.id,
        this.userCode,
        this.imageSrc
      ).then(() => {
        this.$refs.confirm.open(
          "Confirmation",
          "X-ray photo upload completed",
          {
            noconfirm: true
          }
        );

        this.lastImageSrc = this.imageSrc;
      });
    },

    onInvalidUserCode(userCode) {
      this.userCode = userCode;
      this.isUserCodeValid = false;

      this.imageSrc = "";
      this.lastImageSrc = "";
    },

    onValidUserCode(userCode) {
      this.userCode = userCode;
      this.isUserCodeValid = true;

      GetXraySubmission(this.activeService.id, this.userCode)
        .then(submission => {
          this.imageSrc = submission.xray;
          this.lastImageSrc = submission.xray;
        })
        .catch(err => (this.errorMessage = "Error submitting file: " + err));
    },

    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        return;
      }

      if (file.size > 950 * 1024) {
        this.errorMessage =
          "Image size should be less than 950 kB. Please pick another file.";
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imageSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>
